import { render } from "./count.vue?vue&type=template&id=36bd9d5c"
import script from "./count.vue?vue&type=script&lang=js"
export * from "./count.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-quick-search/count.vue'],['render',render],['__file',"count.vue"]])

export default __exports__